import { extractHighschoolEmail, extractHighSchoolMembership } from '@zenid/admin-api';
import type { AccountSchema } from '@zenid/mypage-api';

export function isHighschoolEmail(email?: string): boolean {
  if (!email) {
    return false;
  }
  const domain = import.meta.env.VITE_HIGHSCHOOL_EMAIL_DOMAIN;
  if (!domain) {
    return false;
  }
  return email.endsWith(domain);
}

export type HighschoolAccountInfo = {
  email: string;
  integrated: boolean;
};

// N高生か判定し、高校メールアドレスと統合状況を返却する
export function extractHighschoolAccountInfo(account: AccountSchema): HighschoolAccountInfo | undefined {
  // アカウントの email が N 高のものであれば無条件で N 高アカウントかつ未統合
  if (isHighschoolEmail(account.email)) {
    return { email: account.email, integrated: false };
  }

  // アカウントの email が N 高でない場合、 membership を見て N 高生か確認する
  const highshoolMembership = extractHighSchoolMembership(account.memberships);
  // N 高 membership がない場合は一般ユーザ
  if (!highshoolMembership) {
    return undefined;
  }
  const highschoolEmail = extractHighschoolEmail(highshoolMembership);
  if (!highschoolEmail) {
    return undefined;
  }
  return { email: highschoolEmail, integrated: true };
}
